import { formatPrice, conditionLabel, isNewCond } from "@/lib/store";
import { installmentFor } from "@/lib/pricing";

// Proposta que o lojista monta no painel e manda para o cliente pelo WhatsApp.
export const EMPTY_PROPOSAL = { id: null, client_name: "", client_phone: "", wanted: [], trade: [], cash: true, installments: [12], notes: "" };
export const MAX_ITEMS = 5;

export const stockLabel = (p) => [p.model, p.storage, p.color, conditionLabel(p), p.battery != null && !isNewCond(p.condition) ? `bateria ${p.battery}%` : null].filter(Boolean).join(" · ");

export const toNum = (v) => {
  const s = String(v ?? "").trim();
  const n = Number(s.includes(",") ? s.replace(/\./g, "").replace(",", ".") : s);
  return Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : 0;
};
export const toText = (n) => (Number(n) > 0 ? Number(n).toFixed(2).replace(".", ",") : "");

const sum = (list, key) => list.reduce((s, x) => s + toNum(x[key]), 0);
const filled = (list) => list.filter((x) => String(x.label || "").trim());

export const proposalTotals = (p) => {
  const wanted = sum(filled(p.wanted), "price");
  const traded = sum(filled(p.trade), "value");
  return { wanted, traded, hasTrade: filled(p.trade).length > 0, pay: Math.max(0, wanted - traded), change: Math.max(0, traded - wanted) };
};

export const payLine = (amount, n) => {
  const { each, total } = installmentFor(amount, n);
  return n === 1 ? `1x no cartão: ${formatPrice(total)}` : `${n}x de ${formatPrice(each)} no cartão (total ${formatPrice(total)})`;
};

const itemLines = (list, key) => filled(list).map((x) => `• ${x.label.trim()}${toNum(x[key]) > 0 ? ` — ${formatPrice(toNum(x[key]))}` : ""}`);

export const buildMessage = (p) => {
  const t = proposalTotals(p);
  const name = p.client_name.trim().split(" ")[0];
  const lines = [`Olá${name ? `, ${name}` : ""}! Segue a proposta da *RC iPhones* para você:`, "", "*Você leva:*", ...itemLines(p.wanted, "price")];
  if (t.hasTrade) lines.push("", `*Seu aparelho na troca:*`, ...itemLines(p.trade, "value"));
  lines.push("");
  if (t.change > 0) lines.push(`*Você recebe de volta:* ${formatPrice(t.change)}`);
  else if (t.hasTrade && t.pay === 0) lines.push("*Troca sem diferença:* R$ 0,00");
  else lines.push(`${t.hasTrade ? "*Diferença a pagar:*" : "*Total:*"} ${formatPrice(t.pay)}`);
  const pays = t.pay > 0 ? [p.cash ? `• À vista no Pix ou dinheiro: ${formatPrice(t.pay)}` : null, ...p.installments.map((n) => `• ${payLine(t.pay, n)}`)].filter(Boolean) : [];
  if (pays.length) lines.push("", "*Formas de pagamento:*", ...pays);
  if (p.notes.trim()) lines.push("", p.notes.trim());
  lines.push("", "Qualquer dúvida é só responder aqui.");
  return lines.join("\n");
};

const waPhone = (digits = "") => {
  const d = String(digits).replace(/\D/g, "");
  if (!d) return "";
  return d.length <= 11 ? `55${d}` : d;
};

export const clientWaLink = (phone, text) => `https://wa.me/${waPhone(phone)}?text=${encodeURIComponent(text)}`;

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    el.remove();
    return ok;
  }
};

// Corpo enviado ao servidor (linhas vazias ficam de fora).
export const toPayload = (p, message) => ({
  client_name: p.client_name.trim(),
  client_phone: p.client_phone,
  wanted: filled(p.wanted).map((w) => ({ label: w.label.trim(), price: toNum(w.price), source: w.source, product_id: w.product_id || null })),
  trade: filled(p.trade).map((x) => ({ label: x.label.trim(), value: toNum(x.value), source: x.source })),
  cash: p.cash,
  installments: p.installments,
  notes: p.notes,
  message,
});

export const canSave = (p) => filled(p.wanted).length > 0;

// Proposta salva -> rascunho editável no painel.
export const fromSaved = (d) => ({
  ...EMPTY_PROPOSAL,
  id: d.id,
  client_name: d.client_name || "",
  client_phone: d.client_phone || "",
  wanted: (d.wanted || []).map((w) => ({ ...w, price: toText(w.price) })),
  trade: (d.trade || []).map((x) => ({ ...x, value: toText(x.value) })),
  cash: d.cash !== false,
  installments: Array.isArray(d.installments) ? d.installments : [],
  notes: d.notes || "",
});
